<template>
    <div class="liebiao">
        <!-- <div class="liebiaoTop">首页<span>></span>{{title.parent}}<span>></span>{{title.child}}</div> -->
        <div class="wz">
            <h3>{{articleResp.title}}</h3>
            <p v-html="articleResp.text"></p>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title', 'articleResp']
}
</script>
<style scoped>

.wz {
    color: #000;
    font-size: 14px;
    text-align: center;
}

.wz h3 {
    font-size: 20px;
    text-align: center;
    line-height: 1.5;
    padding: 30px 0;
    position: relative;
}

.wz p {
    text-align: left;
    line-height: 1.5;
}
</style>